import { Element } from "@siteimprove/alfa-dom";
import { WithIndex } from "./pseudo-class.js";
const { hasName, isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#nth-last-of-type-pseudo}
 */
export class NthLastOfType extends WithIndex {
    static of(index) {
        return new NthLastOfType(index);
    }
    constructor(index) {
        super("nth-last-of-type", index);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        const indices = NthLastOfType._indices;
        if (!indices.has(element)) {
            element
                .inclusiveSiblings()
                .filter(isElement)
                .filter(hasName(element.name))
                .reverse()
                .forEach((element, i) => {
                indices.set(element, i + 1);
            });
        }
        return this._index.matches(indices.get(element));
    }
    equals(value) {
        return value instanceof NthLastOfType && value._index.equals(this._index);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (NthLastOfType) {
    NthLastOfType.parse = WithIndex.parseWithIndex("nth-last-of-type", NthLastOfType.of);
})(NthLastOfType || (NthLastOfType = {}));
//# sourceMappingURL=nth-last-of-type.js.map